export default __webpack_public_path__ + "static/media/mx_ad_banner.adf96c33.jpg";